import styled from 'styled-components';

import backgroundSVG from 'assets/bgtexture.svg';
import { colors } from 'styles';

export const ChapterWrapper = styled.div`
  background: url(${backgroundSVG}) ${colors.brandedGreen.base} center;
  height: 100%;
`;
